import React from "react";
import { Grid, Typography } from "@material-ui/core";

type Props = {
  labelFor: string;
  message: string | undefined;
  showError: boolean;
};

const FormErrorMessage = ({ labelFor, message, showError }: Props) => {
  return (
    <>
      {showError && (
        <Grid item>
          <label htmlFor={labelFor} id={`data-${labelFor}-error`}>
            <Typography color={"error"}>{message}</Typography>
          </label>
        </Grid>
      )}
    </>
  );
};

export default FormErrorMessage;
